import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/header'
import Footer from '../components/footer'
import Copyright from '../components/copyright'
import Faqs from '../components/faqs'

const MainLayout = () => {
    return (
        <div>
            <Header />
            <Outlet />
            <Faqs />
            <Footer />
            <Copyright />
        </div>
    )
}

export default MainLayout